module.exports = __webpack_public_path__ + "static/media/img95_R.dfe2c049.jpg";